module.exports = __webpack_public_path__ + "assets/images/template/project/flu_comparison/desktop.svg?v=ed648b94";